<template>
	<div class="gb-photoalbum-content-header">
		<v-layout align-center justify-end row fill-height class="primary gb-photoalbum-content-header-layout ma-0 pa-4" v-bind:style="styleContent">
			<div v-if="canDownLoadAll">
				<div v-if="!download_album">
					<v-btn v-if="select_id" flat large color="white" class="pa-0 ma-0" @click="onDownloadAll">すべてダウンロード</v-btn>
					<v-btn v-else flat large color="grey" class="pa-0 ma-0 disabled">すべてダウンロード</v-btn>
				</div>
			</div>
			<div>
				<v-btn v-if="download_album" flat large color="white" disabled>
					<v-progress-circular
						indeterminate
						color="white"
					></v-progress-circular>
				</v-btn>
			</div>
		</v-layout>
	</div>
</template>
<script>
import {DISPLAY_LIST_TYPE} from '../../data/Const';

export default {
	name: 'GBPhotoAlbumContentHeader',
	props: [
		"display_list_type",
		"download_album",
		"select_id",
	],
	components: {
	},
	methods: {
		onDownloadAll: function() {
			this.$emit('download-all');
		},
	},
	computed: {
		styleContent: function() {
			return {
				'min-width': (this.$store.getters.width - this.$store.getters.listWidth) + 'px',
			}
		},
		canDownLoadAll: function() {
			return this.display_list_type === DISPLAY_LIST_TYPE.PROJECT;
		},
	},
};

</script>
<style>
	.gb-photoalbum-content-header {
		position: relative;
		border:solid 1px #DFDFDF;
		width: 100%;
		height: 59px;
	}
	.gb-photoalbum-content-header .gb-photoalbum-content-header-layout {
		position: relative;
		height: 57px;
	}
</style>
<style scoped>
	.disabled {
		pointer-events: none;
	}
</style>
